// components/widgets/Stakeholders/StakeholderWidgetContainer.jsx
import React, { useEffect, useState } from "react";
import WidgetContainer from "../WidgetContainer.jsx";
import pandaImg from "../../../../../assets/panda_stakeholders.png";
import BeliefScreen from "./BeliefScreen.jsx";
import MyBeliefs from "./MyBeliefs.jsx";
import FinalBeliefScreen from "./FinalBeliefScreen.jsx";
import { progressService } from "../../../../../services/progressService.js";

const unwrapPayload = (node) => {
  let current = node;
  let depth = 0;
  const maxDepth = 6;

  while (
    current &&
    typeof current === "object" &&
    (current.payload || current.data) &&
    depth < maxDepth
  ) {
    current = current.payload || current.data;
    depth += 1;
  }

  return current;
};

const BeliefContainer = ({
  userId,
  subsectionId,
  onComplete,
  onPhaseChange,
}) => {
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const loadUserProfile = async () => {
      try {
        const res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "identity",
          "current_identity_reflection"
        );

        const payload = unwrapPayload(
          res?.data?.payload || res?.payload || res?.data || res
        );

        if (!payload || typeof payload !== "object") {
          setUserProfile(null);
          return;
        }

        setUserProfile({
          name: payload.userName || payload.name || "You",
          avatar: payload.profileImage || payload.image || payload.avatar || "",
        });
      } catch (error) {
        console.error("Failed to load user profile image:", error);
        setUserProfile(null);
      }
    };

    loadUserProfile();
  }, [userId]);

  return (
    <WidgetContainer
      userId={userId}
      subsectionId={subsectionId}
      onComplete={onComplete}
      onPhaseChange={onPhaseChange}
      intro={{
        image: pandaImg,
        title: "Beliefs about myself",
        description:
          "What traits do you think you display? Here's a quick activity to give you reality check.",
        buttonLabel: "Get Started",
      }}
      steps={[
        {
          id: "builder",
          // WidgetContainer will pass onDataChange automatically.
          component: BeliefScreen,
          props: { user: userProfile },
        },
        {
          id: "builder",
          // WidgetContainer will pass onDataChange automatically.
          component: MyBeliefs,
          props: { user: userProfile },
        },
        {
          id: "builder",
          // WidgetContainer will pass onDataChange automatically.
          component: FinalBeliefScreen,
          props: { user: userProfile },
        },
      ]}
    />
  );
};

export default BeliefContainer;
